<template>
  <div class="conversation-preview">
    <profile-picture
      :profilePicture="contact ? contact.profilePicture : undefined"
      class="profile-picture"
    />
    <div class="message-preview-text">
      <h5 class="contact-name">{{ contactFullName }}</h5>
      <p>{{ textPreview }}</p>
    </div>
  </div>
</template>
<script>
import ProfilePicture from "../../UI/ListItems/ListItemComponents/ProfilePicture.vue";
export default {
  data() {
    return {};
  },
  computed: {
    contact() {
      let nonUsers = this.conversation.participantKeys.filter((x) => {
        return x ? x.userId !== this.$store.state.user.userId : false;
      });
      if (nonUsers[0]) {
        return nonUsers[0];
      } else {
        return {
          given_name: "Deleted",
          family_name: "user",
        };
      }
    },
    contactFullName() {
      return `${this.contact.given_name} ${this.contact.family_name}`;
    },
    messages() {
      if (this.conversation) {
        if (this.conversation.messages) {
          return Object.values(this.conversation.messages);
        } else {
          return [];
        }
      } else {
        return [];
      }
    },
    textPreview() {
      if (this.messages.length > 0) {
        let recentMessage = this.messages[this.messages.length - 1].body;
        if (recentMessage.length > 90) {
          return recentMessage;
        } else {
          return recentMessage;
        }
      } else {
        return "No messages in this thread.";
      }
    },
  },
  methods: {
    // async getContact() {
    //   let participants = this.conversation.participantKeys.filter((x) => {
    //     return x.userId !== this.$store.state.user.userId;
    //   });
    //   if (participants[0].userId !== "system") {
    //     this.conversation.participantKeys = await Promise.all(
    //       this.conversation.participantKeys.map((x) => {
    //         return this.$store.dispatch("getContactListItem", x);
    //       })
    //     );
    //   } else {
    //     this.contact = {
    //       given_name: "Spin",
    //       family_name: "|| Cole",
    //       profilePicture:
    //         "https://spindjappstorage140016-prod.s3.amazonaws.com/public/f48f259e-37d9-4003-be97-7181858b98aa1649263424983",
    //     };
    //   }
    // },
  },
  created() {
    // this.getContact();
  },
  //   todo : add time
  //   todo : add read flag
  //   todo : add live update
  components: {
    // ListItemStyleWrapper,
    ProfilePicture,
  },
  props: ["conversation"],
};
</script>
<style scoped>
.conversation-preview {
  height: 60px;
  display: flex;
  align-items: center;
  padding: 10px;
  margin: 10px;
  width: calc(100% - 20px);
  box-sizing: border-box;
  cursor: pointer;
  border-radius: 10px;
  background-color: var(--backgroundColor);
}

.conversation-preview:hover {
  filter: drop-shadow(0px 8px 6px var(--shadow));
}

.profile-picture {
  margin-right: 15px;
}

.message-preview-text > p {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.message-preview-text {
  text-align: left;
  width: 100%;
}

.contact-name {
  margin: 5px 0;
}
p {
  font-size: 0.75rem;
  margin: 0;
  overflow: hidden;
}
</style>
